/* eslint-disable */
import Subpage from "./subpage";
import ReviewMotivation from "~/ui/review/motivation";
import SortBox from "~/ui/sortbox";
import MyReview from "./myreview";
import { IUserReviewItem, IReviewResponse } from "./interfaces";
import { node } from "~/util/dom";
import { updateListFromCache, emptyCache } from "~/util/reviews-cache";
import { LOG_SOURCE, REVIEWS_PER_PAGE, REVIEWS_PER_PAGE_FIRST_LOAD, SCROLL_TRESHOLD, SORT_OPTIONS } from "~/mymaps2/reviews/constants";
import { addListener, removeListeners } from "~/lib/signals";
import { store } from "~/state/store";
import { isTwin } from "~/util/review";
import { getUserReviews, REVIEWS_ORDER } from "~/util/providers/review";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { useScroll } from "~/util/usescroll";
import { getIcon } from "~/util/providers/poiagg";
import { setCoordinates } from "~/state/map/state";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import { WASM_ZINDEX } from "~/wasm/const";
import WasmBulkMode from "~/wasm/store/bulk-mode";

interface IMarkers {
	[key: string]: any;
}

interface IReviewItemsOptions {
	tabs: HTMLUListElement;
}

type TMarkersData = {[key: string]: { id: string; coords: any; opts: any; wasm: any; }};

export default class MyReviews extends Subpage {
	_offset: number;
	_resultCount: number;
	_loading: boolean;
	_layer: any;
	_markers: IMarkers;
	_markersData: TMarkersData;
	_wasmMarkers: Array<WasmStoreMarker>;
	_curWasmMarkers: {[key: string]: WasmStoreMarker; };
	_sc: Array<any>;
	_list: HTMLUListElement;
	_tabs: HTMLUListElement;
	_sortBox: SortBox;
	_topBar: HTMLDivElement;
	_orderValue: REVIEWS_ORDER;
	_detailMarker: any;
	_onlyRejected: boolean;
	_scrollListener: ReturnType<typeof useScroll>;
	_wasmHoverMarker: WasmStoreMarker;

	constructor({ tabs }: IReviewItemsOptions) {
		super();

		this._tabs = tabs;
		this._offset = 0;
		this._resultCount = 0;
		this._orderValue = SORT_OPTIONS[0].value;
		this._loading = false;
		this._sc = [];
		this._layer = Scene.createLayerMarker();
		this._markers = {};
		this._markersData = {};
		this._list = node("ul", { className: "myreviews__list" });
		this._topBar = node("div", { className: "myreviews__topbar" });
		this._container.classList.add("myreviews");
		this._detailMarker = null;
		this._onlyRejected = false;
		this._scrollListener = null;
		this._wasmMarkers = [];
		this._curWasmMarkers = {};
		this._wasmHoverMarker = null;
	}

	activate() {
		super.activate();

		if (this._active) {
			return;
		}

		this._active = true;

		this._sc = [
			addListener(this, "detail-activated", "_detailActivated"),
			addListener(this, "detail-deactivated", "_detailDeactivated"),
		];
		this._scrollListener = useScroll({
			threshold: SCROLL_TRESHOLD,
			onScroll: (isBottom: boolean) => {
				const reviewsPerPage = this._offset === 0 ? REVIEWS_PER_PAGE_FIRST_LOAD : REVIEWS_PER_PAGE;

				if (
					!this._loading
					&& isBottom
					&& this._resultCount > 0
					&& this._offset + reviewsPerPage < this._resultCount
				) {
					this._offset += reviewsPerPage;

					this._loadReviews();
				}
			},
		});
		this._offset = 0;
		this._resultCount = 0;
		this._container.innerHTML = "";
		this._list.innerHTML = "";
		this._topBar.innerHTML = "";
		this._topBar.appendChild(this._tabs);
		this._sortBox = new SortBox({
			options: SORT_OPTIONS,
			onSelect: (value, option) => {
				Mapy.getComponent("logger").log("click", {
					text: _(option.title),
					source: LOG_SOURCE,
					section: "reviews",
				});

				this._orderValue = value;
				this._offset = 0;
				this._container.innerHTML = "";
				this._list.innerHTML = "";
				this._container.appendChild(this._topBar);

				emptyCache();
				this._loadReviews();
			},
			selectedIndex: SORT_OPTIONS.findIndex(option => option.value === this._orderValue),
		});
		this._topBar.appendChild(this._sortBox.node);
		this._container.appendChild(this._topBar);
		this._loadReviews();
		Scene.addLayer(this._layer).enable();
	}

	deactivate() {
		super.deactivate();

		if (!this._active) {
			return;
		}

		this._active = false;

		this._sortBox.destroy();
		removeListeners(this._sc);
		this._sc = [];
		this._scrollListener && this._scrollListener();
		this._scrollListener = null;
		this._layer.removeAll();
		this._markers = {};
		this._markersData = {};
		this._layer.disable();
		Scene.removeLayer(this._layer);

		const wasmBulk = new WasmBulkMode();

		for (const wasmMarker of this._wasmMarkers) {
			wasmBulk.removeMarker(wasmMarker);
		}

		wasmBulk.run();

		this._wasmMarkers = [];
		this._curWasmMarkers = {};
	}

	async _loadReviews() {
		if (this._loading) {
			return;
		}

		this._loading = true;
		Mapy.getComponent("loader").start();
		const loader = node("img", { src: "/img/loader.gif", width: 24, height: 24, className: "myreviews__loader", crossOrigin: "anonymous" });
		const { user } = store.getState().user;

		this._container.appendChild(loader);

		try {
			const response: IReviewResponse = await getUserReviews({
				userPublicId: user.userPublicId,
				offset: this._offset,
				limit: this._offset === 0 ? REVIEWS_PER_PAGE_FIRST_LOAD : REVIEWS_PER_PAGE,
				order: this._orderValue,
				onlyRejected: this._onlyRejected,
			});

			if (response?.reviews?.length > 0) {
				this._resultCount = response.totals.ok;

				// pokud nic nema a v odpovedi to uplne chybi, tak si udelame fake
				if (!response?.reviews) {
					response.reviews = [];
				}

				// updatujeme z cache
				response.reviews = updateListFromCache(response.reviews, this._offset > 0);
				response.reviews = response.reviews.filter(item => Object.keys(item.description).length > 0);
				// mapa
				this._updateMap(response.reviews, this._offset === 0);

				if (response?.reviews?.length) {
					let motivation: ReviewMotivation = null;

					if (this._offset === 0) {
						motivation = new ReviewMotivation({
							count: this._resultCount,
							label: "mymap.reviews.motivation",
							onChange: (event: Event) => {
								const target = event.target as HTMLInputElement;

								this._onlyRejected = target.checked;
								this._offset = 0;
								this._container.innerHTML = "";
								this._list.innerHTML = "";
								this._container.appendChild(this._topBar);

								emptyCache();
								this._loadReviews();
							},
							rejected: response.totals.rejected,
							onlyRejected: this._onlyRejected,
						});

						this._container.appendChild(motivation.node);
					}

					response.reviews.forEach((data, index) => {
						if (!data?.description || !Object.keys(data.description).length) {
							return;
						}

						try {
							const review = new MyReview({
								data,
								user: response.user,
								onEdit: () => {
									this.deactivate();
									this.activate();
								},
								onDelete: data => {
									review.node.remove();
									if (data?.state === "rejected") {
										motivation.rejected = motivation.rejected - 1;
									} else {
										motivation.count = motivation.count - 1;
									}
								},
								index,
								isCurrentUser: true,
								update: data.actual === false,
								analytics: {
									source: LOG_SOURCE,
									section: "reviews",
									rating_layout: "0",
									position: "top",
									refused: data?.state === "rejected" ? 1 : 0,
									sourcePoi: data.review_poi.source,
									typeid: data.description.typeId,
									firmTwin: isTwin(data.description) ? 1 : 0,
								},
								onEnter: () => {
									this._showMarker(`${data.description.source}_${data.description.id}`, true);
								},
								onLeave: () => {
									this._showMarker(`${data.description.source}_${data.description.id}`);
								},
							});

							this._list.appendChild(review.node);
						} catch (exc) {
							console.log(exc);
						}
					});

					if (this._offset === 0) {
						this._container.appendChild(this._list);
					}
				} else {
					throw Error("jsme na konci");
				}
			} else {
				throw Error("nejsou data");
			}
		} catch(ex) {
			console.log(ex);
			// nename nic, udelame empty stranku
			if (this._resultCount === 0) {
				const motivation = new ReviewMotivation({
					count: this._resultCount,
					label: "mymap.reviews.motivation",
				});

				this._container.appendChild(motivation.node);
				this._container.appendChild(node("p", { className: "myreviews__emptyText", innerHTML: _("mymap.reviews.emptyMy") }));
				this._container.appendChild(node("img", { className: "myreviews__emptyImg", src: "/img/mymap/empty-myreviews.svg", crossOrigin: "anonymous" }));
			}
		} finally {
			Mapy.getComponent("loader").end();
			loader.remove();
			this._loading = false;
		}
	}

	_updateMap(reviews: Array<IUserReviewItem>, zoomToReviews?: boolean) {
		const newMarkers: IMarkers = {};
		const newMarkersData: TMarkersData = {};
		const reviewsCoords = [];
		const curWasmIds = Object.keys(this._curWasmMarkers);
		const newWasmMarkers: Array<WasmStoreMarker> = [];
		const wasmBulk = new WasmBulkMode();

		reviews.forEach(review => {
			const id = `${review.description.source}_${review.description.id}`;
			const wasmInd = curWasmIds.indexOf(id);

			if (wasmInd !== -1) {
				curWasmIds.splice(wasmInd, 1);
			}

			const typeId = review.description.typeId;
			const icon = review.description.icon && "1" in review.description.icon ? review.description.icon["1"] : getIcon(typeId, { scale: 1 });
			const icon2x = review.description.icon && "2" in review.description.icon ? review.description.icon["2"] : getIcon(typeId, { scale: 2 });
			const wasmIcon = icon2x || icon;
			const coords = Scene.coordsFromWGS84(review.description.mark.lon, review.description.mark.lat);

			if (id in this._curWasmMarkers) {
				newWasmMarkers.push(this._curWasmMarkers[id]);
			} else {
				const wasmMarker = wasmBulk.createMarker({
					type: wasmIcon ? "small" : "small-universal",
					lon: coords.x,
					lat: coords.y,
					zIndex: WASM_ZINDEX.marker.myReviews,
					interactionType: "click-hover",
					customData: {
						url: wasmIcon,
						poi: {
							source: review.description.source,
							id: review.description.id as number,
						},
					},
				});

				newWasmMarkers.push(wasmMarker);
				this._curWasmMarkers[id] = wasmMarker;
			}

			// existuje uz marker? tak jen presuneme do noveho objektu
			if (id in this._markers) {
				newMarkers[id] = this._markers[id];
				newMarkersData[id] = this._markersData[id];

				return;
			}

			// jeste neexistoval, tak ho pridame
			const onClick = () => {
				Mapy.getComponent("detail").setState({
					source: review.description.source,
					id: review.description.id,
					backTitle: _("mymap.switcher.reviews"),
				}).then(() => {
					Mapy.getComponent("history").save();
				}, () => {});
			};
			const opts = {
				type: icon ? Scene.VISUAL.MARKER_WINDY.SMALL : Scene.VISUAL.MARKER_WINDY.UNIVERSAL,
				...icon ? { icon, srcset: `${icon} 1x${icon2x ? `, ${icon2x} 2x` : ""}` } : {},
				m3dData: {
					click: onClick,
				},
			};
			const marker = Scene.createMarkerMapyWindy(coords, id, opts);

			marker.addEventListener("click", onClick);
			newMarkers[id] = marker;
			newMarkersData[id] = {
				coords,
				id,
				opts,
				wasm: {
					url: wasmIcon,
				},
			};
			this._layer.addMarker(marker);
			reviewsCoords.push(coords);
		});

		for (const oldId of curWasmIds) {
			wasmBulk.removeMarker(this._curWasmMarkers[oldId]);
			delete this._curWasmMarkers[oldId];
		}

		this._wasmMarkers = newWasmMarkers;

		// co neskoncilo v novem objektu a je ve starem, to odebereme
		for (const id in this._markers) {
			if (!(id in newMarkers)) {
				this._layer.removeMarker(this._markers[id]);
			}
		}

		// zapamatujeme si nove
		this._markers = newMarkers;
		this._markersData = newMarkersData;

		wasmBulk.run();

		if (zoomToReviews) {
			const data = Scene.computeCenterZoom(reviewsCoords);
			const [longitude, latitude] = data[0].toWGS84();

			store.dispatch(setCoordinates({
				longitude,
				latitude,
				zoom: data[1],
				animate: true,
			}));
		}
	}

	_detailActivated() {
		this._layer.disable();
	}

	_detailDeactivated() {
		this.deactivate();
		this.activate();
		this._layer.enable();
	}

	_showMarker(id: string, isBig?: boolean) {
		const data = this._markersData[id];

		if (this._wasmHoverMarker) {
			this._wasmHoverMarker.destroy();
			this._wasmHoverMarker = null;
		}

		if (!isBig && this._detailMarker) {
			this._layer.removeMarker(this._detailMarker);
			this._detailMarker = null;
		} else if (isBig && !this._detailMarker && data) {
			this._detailMarker = Scene.createMarkerMapyWindy(data.coords, undefined, {
				...data.opts,
				type: Scene.VISUAL.MARKER_WINDY.BIG,
			});
			this._layer.addMarker(this._detailMarker);

			const cont = this._detailMarker.getContainerSync();

			if (cont) {
				cont.style.zIndex = 1000;
			}
		}

		if (isBig) {
			this._wasmHoverMarker = new WasmStoreMarker({
				type: "big",
				lon: data.coords.x,
				lat: data.coords.y,
				zIndex: WASM_ZINDEX.marker.myReviewsHover,
				customData: {
					url: data.wasm.url,
				},
			});
		}
	}
}
